import { render } from "./ReadBooks.vue?vue&type=template&id=23fdafcf&scoped=true"
import script from "./ReadBooks.vue?vue&type=script&lang=js"
export * from "./ReadBooks.vue?vue&type=script&lang=js"

import "./ReadBooks.vue?vue&type=style&index=0&id=23fdafcf&scoped=true&lang=css"

import exportComponent from "C:\\Surilova\\FrontEnd\\Bookshelf-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fdafcf"]])

export default __exports__